import template from './taskForm.html';

function TaskFormController(
  $scope,
  $log,
  $translate,
  $timeout,
  $rootScope,
  $q,
  $window,
  groupsService,
  siteService,
  taskTypesService,
  TaskTemplate,
  Task,
  moment,
  toastWrapperService,
  timezoneService
) {
  const $ctrl = this;
  const newTask = angular.extend($ctrl.task, { priority: 2, status: 1 });

  $ctrl.showMeridian = timezoneService.userTimeHourFormat === 12;

  const displayHoursFormat = `${$ctrl.showMeridian ? 'h:mm A' : 'H:mm'}`;
  const displayDateFormat = 'ddd MMM D';

  $scope.$watch('$ctrl.formData.deadline', () => {
    $ctrl.formData.deadlineDisplayTime = moment($ctrl.formData.deadline).format(displayHoursFormat);
    $ctrl.formData.deadlineDisplayDate = moment($ctrl.formData.deadline).format(displayDateFormat);
  });

  $scope.$watch('$ctrl.formData.startDate', (newStartDate, oldStartDate) => {
    // Ensure that time that was initialized by timepicker is adjusted according to timezone
    if (newStartDate && !oldStartDate) {
      $ctrl.formData.startDate = timezoneService.getTzDate(newStartDate);
    }

    $ctrl.formData.startDisplayTime = moment(newStartDate).format(displayHoursFormat);
    $ctrl.formData.startDisplayDate = moment(newStartDate).format(displayDateFormat);
  });


  function checkReassigned() {
    const existingTask = $ctrl.formData.id;
    const alreadyClaimed = $ctrl.formData.status === 3;
    const reassigned = $ctrl.formData.assignedUser !== $ctrl.task.assignedUser;

    if (existingTask && alreadyClaimed && reassigned) {
      /* Revert to 'group assigned' status if the assigned user 
      *  is changed for a task that has already been claimed
      */
      $ctrl.reassigned = true;
      $ctrl.formData.status = 1;
    }
  }

  function checkForDeadline() {
    if ($ctrl.template && $ctrl.template.deadline) {
      const tzDate = timezoneService.getTzDate(
        (moment().unix().valueOf() + $ctrl.template.deadline) * 1000
      );

      $ctrl.formData.deadline = tzDate.getTime();
    } else {
      $ctrl.formData.deadline = null;
    }
  }

  function setTaskTypeCustomFields(selectedTaskTypeId) {
    const selectedTaskType = $ctrl.types.find(type => type.id === selectedTaskTypeId);

    if (selectedTaskType) {
      $ctrl.customFields = selectedTaskType.customFields || [];

      if ($ctrl.formData && $ctrl.formData.customFields) {
        $ctrl.formData.customFields = $ctrl.customFields.reduce((acc, curr) => {
          acc[curr.name] = $ctrl.formData.customFields[curr.name];
          return acc;
        }, {});
      }
    }
  }

  function applyTemplateData() {
    if ($ctrl.alerts.length) {
      $ctrl.alerts = [];
    }

    const templateProps = [
      'priority',
      'type',
      'website'
    ];

    setTaskTypeCustomFields($ctrl.template.type);

    if (!$ctrl.template.assigneeType || $ctrl.template.assigneeType === 'group') {
      templateProps.push('assignedGroup');
      $ctrl.assignedType = 'group';
    } else {
      $ctrl.assignedType = 'user';
      $ctrl.group = null;
      $ctrl.formData.assignedGroup = null;
    }

    angular.forEach(templateProps, (prop) => {
      if ($ctrl.template[prop] || $ctrl.template[prop] === 0) {
        $ctrl.formData[prop] = $ctrl.template[prop];
      }
    });

    if ($ctrl.template.id) {
      $ctrl.formData.taskTemplateId = $ctrl.template.id;
    }

    if ($ctrl.formData.assignedGroup) {
      groupsService.convertIdToName($ctrl.formData.assignedGroup).then((response) => {
        $ctrl.group = response;
      });
    }

    checkForDeadline();
  }

  function clearForm() {
    $ctrl.alerts = [];
    $ctrl.customFields = [];
    $ctrl.template = null;
    $ctrl.user = null;
    $ctrl.group = null;
    $ctrl.formData = new Task(newTask);
    $ctrl.assignedType = 'group';
    $ctrl.submitted = false;
  }

  function validateFormData() {
    if ($ctrl.group && groupsService.directory[$ctrl.formData.assignedGroup] !== $ctrl.group) {
      $ctrl.formData.assignedGroup = null;
      $ctrl.alerts.push({ type: 'danger', msg: $translate.instant('PLEASE_SELECT_VALID_GROUP') });
      return true;
    }

    if (!$ctrl.formData.assignedGroup && $ctrl.formData.status === 4) {
      $ctrl.alerts.push({ type: 'danger', msg: $translate.instant('TASK_REJECTION_WARNING') });
      return true;
    }

    if ($ctrl.formData.id && $ctrl.formData.status === 1 && !$ctrl.formData.assignedGroup) {
      $ctrl.alerts.push({ type: 'danger', msg: $translate.instant('PLEASE_SELECT_VALID_GROUP') });
      return true;
    }

    if ($ctrl.formData.id && $ctrl.formData.status === 2 && !$ctrl.formData.assignedUser) {
      $ctrl.alerts.push({ type: 'danger', msg: $translate.instant('PLEASE_SELECT_VALID_USER') });
      return true;
    }

    if (
      $ctrl.template
      && $ctrl.template.deadlineRequired
      && !$ctrl.hideTemplateForm
      && !$ctrl.formData.deadline
    ) {
      $ctrl.alerts.push({ type: 'danger', msg: $translate.instant('DEADLINE_REQUIRED') });
      return true;
    }

    if (
      $ctrl.formData.startDate
      && $ctrl.formData.deadline
      && moment($ctrl.formData.startDate).isSameOrAfter($ctrl.formData.deadline)
    ) {
      $ctrl.alerts.push({ type: 'danger', msg: $translate.instant('START_DEADLINE_DATE_ERROR') });
      return true;
    }

    return false;
  }

  function successCallback(task) {
    $ctrl.requestRunning = false;

    $ctrl.isOpen = $ctrl.isOpen ? !$ctrl.isOpen : $ctrl.isOpen;

    if ($ctrl.formData.id) {
      $rootScope.$broadcast('task-updated', { task });
    } else {
      clearForm();
      $scope.$emit('task-created', { task });

      if ($ctrl.external) {
        const postMsgData = {
          task,
          eventType: 'wsk.task.create'
        };

        $window.parent.postMessage(postMsgData, $window.origin);
      }
    }
  }

  function errorCallback(response) {
    $ctrl.requestRunning = false;

    if (response.data && response.data.error) {
      $ctrl.alerts.push({ type: 'warning', msg: response.data.error });
    } else {
      $ctrl.alerts.push({ type: 'warning', msg: response });
    }
  }

  if ($ctrl.task.latestEvent && $ctrl.task.latestEvent.assignedUser) {
    const { assignedUser, assignedUserDisplayName } = $ctrl.task.latestEvent;
    $ctrl.user = { username: assignedUser, name: assignedUserDisplayName };
  }

  $ctrl.$onInit = () => {
    $ctrl.typeaheadConfigs = {
      editable: false,
      selectOnExact: true,
      selectOnBlur: true,
      focusOnSelect: false
    };

    $ctrl.hideTemplateForm = true;

    if (!$ctrl.task.id) {
      $ctrl.task = new Task(newTask);
      $ctrl.assignedType = 'group';
      $ctrl.toggleCustomForm();
    }

    $ctrl.formData = angular.copy($ctrl.task);
    if ($ctrl.formData.startDate) {
      $ctrl.formData.startDate *= 1000;
    }

    if ($ctrl.formData.latestEvent) {
      const availableProps = [
        'status',
        'priority',
        'startDate',
        'deadline',
        'assignedUser',
        'assignedGroup',
        'customFields'
      ];

      angular.forEach(availableProps, (prop) => {
        $ctrl.formData[prop] = $ctrl.formData.getLatestEventProp(prop);
      });

      if ($ctrl.formData.deadline) {
        $ctrl.formData.deadline = timezoneService.getTzDate($ctrl.formData.deadline);
      }

      if ($ctrl.formData.startDate) {
        $ctrl.formData.startDate = timezoneService.getTzDate($ctrl.formData.startDate);
      }
    }

    $ctrl.submitted = false;
    $ctrl.alerts = [];

    const assignedGroup = $ctrl.formData.assignedGroup;
    const availableData = [
      siteService.getWebsites(),
      taskTypesService.getTaskTypes(),
      taskTypesService.getTaskStatuses(),
      groupsService.getGroups()
    ];

    if (assignedGroup) {
      availableData.push(groupsService.convertIdToName(assignedGroup));
    }

    if (!$ctrl.task.id) {
      availableData.push(TaskTemplate.search({ page: 0, size: 5 }));
    }

    $q.all(availableData).then((data) => {
      const [sites, types, statuses, groups] = data;
      $ctrl.sites = sites;
      $ctrl.types = types;
      $ctrl.statuses = statuses;
      $ctrl.groups = groups;
      $ctrl.group = assignedGroup ? data[4] : null;

      if (!$ctrl.task.id) {
        const templateData = data[data.length - 1];

        $ctrl.templates = templateData;
        $ctrl.template = templateData[0] || null;
        $ctrl.searchTemplateName = $ctrl.template ? $ctrl.template.name : '';

        const [firstSite] = $ctrl.sites;
        const defaultSite = $ctrl.sites.find(site => site.is_default_website) || firstSite;
        $ctrl.formData.website = defaultSite._id;
      }

      if ($ctrl.template) {
        applyTemplateData();
      } else {
        setTaskTypeCustomFields($ctrl.formData.type);
      }

      $ctrl.groupSelect({ id: $ctrl.formData.assignedGroup });

      if ($ctrl.user) {
        $ctrl.userSelect({ username: $ctrl.user.username });
      }
    }, (response) => {
      if (response.config && response.config.url) {
        toastWrapperService.createToast(`${$translate.instant('ERROR_GETTING_RESOURCES_PATH')}${response.config.url.slice(3)}`, 'danger');
      } else {
        toastWrapperService.createToast($translate.instant('ERROR_GETTING_REQUIRED_RESOURCE'), 'danger');
      }

      $log.error(response);
    });
  };

  $ctrl.toggleCustomForm = () => {
    $ctrl.alerts = [];
    $ctrl.hideTemplateForm = !$ctrl.hideTemplateForm;

    if ($ctrl.hideTemplateForm && $ctrl.formData.taskTemplateId) {
      $ctrl.formData.taskTemplateId = null;
      $ctrl.formData.type = $ctrl.template.type;
    } else if (!$ctrl.hideTemplateForm && $ctrl.template) {
      $ctrl.formData.taskTemplateId = $ctrl.template.id;
      $ctrl.assignedType = $ctrl.template.assigneeType || 'group';

      setTaskTypeCustomFields($ctrl.template.type);
    }
  };

  $ctrl.toggleDropdown = ($event, subject) => {
    $event.preventDefault();
    $event.stopPropagation();

    $ctrl[subject] = !$ctrl[subject];
  };

  $ctrl.setToday = (subject) => {
    const tzDate = timezoneService.getTzDate(new Date());
    tzDate.setHours(0, 0, 0, 0);
    $ctrl.formData[subject] = tzDate.getTime();
  };

  $ctrl.clear = (subject) => {
    $ctrl.formData[subject] = null;
    if (subject === 'assignedUser') {
      checkReassigned();
      $ctrl.user = null;
    }

    if (subject === 'assignedGroup') {
      $ctrl.group = null;
    }

    if (subject === 'template') {
      $ctrl.searchTemplateName = '';
      clearForm();
    }
  };

  $ctrl.switchTemplate = () => {
    applyTemplateData();
  };

  $ctrl.adjustUserStatus = () => {
    $ctrl.userFocus = false;
    let newStatus = $ctrl.formData.status;

    if ($ctrl.formData.id && $ctrl.user) {
      newStatus = 2;
    } else if ($ctrl.formData.id && $ctrl.group) {
      newStatus = 1;
    }

    $ctrl.formData.status = newStatus;
  };

  $ctrl.adjustGroupStatus = () => {
    $ctrl.groupFocus = false;
    let newStatus = $ctrl.formData.status;

    if ($ctrl.formData.id && $ctrl.group) {
      newStatus = 1;
    } else if ($ctrl.formData.id && $ctrl.user) {
      newStatus = 2;
    }

    $ctrl.formData.status = newStatus;
  };

  $ctrl.userSelect = ($item) => {
    $ctrl.formData.assignedUser = $item.username;
  };

  $ctrl.groupSelect = ($item) => {
    $ctrl.formData.assignedGroup = $item.id;
  };

  // Generates results in the task template typeahead
  this.searchTemplates = (name = '') =>
    TaskTemplate.search({ name, page: 0, size: 10 })
      .then(results => results);

  // Applies template data to the form
  this.templateSelect = ($item) => {
    const existingTemplate = this.templates.find(t => t.id === $item.id);

    if (!existingTemplate) {
      // Keep the length consistent; add the newly selected template to the top of the list
      this.templates = [$item, ...this.templates].slice(0, 5);
    }

    this.template = existingTemplate || $item;
    this.searchTemplateName = this.template.name;

    if (this.template) {
      applyTemplateData();
    }
  };

  $ctrl.reset = () => {
    clearForm();
  };

  $ctrl.update = () => {
    $ctrl.alerts = [];

    $ctrl.submitted = true;

    const invalid = validateFormData();

    if (invalid) {
      return;
    }

    $ctrl.tasksForm.$setSubmitted();
    $timeout(() => {
      if ($ctrl.tasksForm.$invalid && !$ctrl.hideTemplateForm) {
        $ctrl.alerts.push({ type: 'danger', msg: $translate.instant('PLEASE_SELECT_VALID_TEMPLATE') });
        return;
      } else if ($ctrl.tasksForm.$invalid) {
        return;
      }

      $ctrl.requestRunning = true;

      if (!$ctrl.formData.id && $ctrl.assignedType === 'group') {
        $ctrl.formData.assignedUser = null;
      } else if (!$ctrl.formData.id && $ctrl.assignedType === 'user') {
        $ctrl.formData.assignedGroup = null;
        $ctrl.formData.status = 2;
      }
      if ($ctrl.formData.type > 0) {
        const authoringAppAry = $ctrl.types.filter(type =>
          type.id === $ctrl.formData.type && type.authoringApp);
        if (authoringAppAry.length) {
          $ctrl.formData.authoringApp = authoringAppAry[0].authoringApp;
        }
      }

      const formDataCopy = angular.copy($ctrl.formData);

      const getCurrentTimeStamp = (date) => {
        const localDate = new Date(date);
        const tzDate = new Date(localDate.toLocaleString('en-US', {
          timeZone: timezoneService.userTimezone
        }));

        const diff = localDate.getTime() - tzDate.getTime();
        return new Date(localDate.getTime() + diff).getTime();
      };

      if (formDataCopy.startDate) {
        formDataCopy.startDate = getCurrentTimeStamp(formDataCopy.startDate);
      }

      if (formDataCopy.deadline) {
        formDataCopy.deadline = getCurrentTimeStamp(formDataCopy.deadline);
      }

      if (!$ctrl.formData.id) {
        $ctrl.task.save(
          formDataCopy, $ctrl.task.storyID
        ).then(successCallback, errorCallback);
      } else {
        $ctrl.task.update(formDataCopy).then(successCallback, errorCallback);
      }
    });
  };

  $ctrl.cancel = () => {
    if ($ctrl.external) {
      const postMsgData = {
        eventType: 'cancel'
      };

      $window.parent.postMessage(postMsgData, $window.origin);
    }
  };

  $ctrl.selectedTaskTypeChanged = () => {
    setTaskTypeCustomFields($ctrl.formData.type);
  };
}

const taskForm = {
  template,
  bindings: {
    task: '<',
    standalone: '@',
    external: '@'
  },
  transclude: true,
  controller: [
    '$scope',
    '$log',
    '$translate',
    '$timeout',
    '$rootScope',
    '$q',
    '$window',
    'groupsService',
    'siteService',
    'taskTypesService',
    'TaskTemplate',
    'Task',
    'moment',
    'toastWrapperService',
    'timezoneService',
    TaskFormController
  ]
};

export default function (ngModule) {
  ngModule.component('taskForm', taskForm);
  ngModule.controller('TaskFormController', TaskFormController);
}
